import script from "./Letters.vue?vue&type=script&setup=true&lang=js"
export * from "./Letters.vue?vue&type=script&setup=true&lang=js"

import "./Letters.vue?vue&type=style&index=0&id=3a327e82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a327e82"]])

export default __exports__